import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

import RequestQuoteForm from './RequestQuoteForm';
import { REQUEST_QUOTE_FORM } from '../../../constants/globals';
import { postQuoteRequestForm } from '../../../services/formSubmit';

export const RequestQuoteDialog = ({ open, onClose }) => {
  const onSubmit = (value) => {
    postQuoteRequestForm(value).subscribe(res => console.log(res));
    onClose();
  }

  return (
    <Dialog
      open={open}
      // onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Request for Quote</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please provide following information to help you with quote.
        </DialogContentText>
        <RequestQuoteForm
          onSubmit={onSubmit}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="submit"
          form={REQUEST_QUOTE_FORM}
          onClick={onClose}
          color="primary"
        >
        Submit 
        </Button>
      </DialogActions>
    </Dialog>
  );
}

RequestQuoteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default RequestQuoteDialog;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Report/RequestQuoteDialog.jsx